function getAuthoritativeBoundaryPoints(fieldState) {
  if (!Array.isArray(fieldState?.boundaries)) {
    return [];
  }

  const points = fieldState.boundaries.filter(
    (point) => Number.isFinite(point?.lat) && Number.isFinite(point?.lng)
  );

  return points.length >= 3 ? points : [];
}

function hasAuthoritativeFieldBoundaries(fieldState) {
  return getAuthoritativeBoundaryPoints(fieldState).length >= 3;
}

function calculateBoundaryCentroid(boundaries) {
  if (!Array.isArray(boundaries) || boundaries.length < 3) {
    return null;
  }

  const totals = boundaries.reduce(
    (current, point) => ({
      lat: current.lat + point.lat,
      lng: current.lng + point.lng,
    }),
    { lat: 0, lng: 0 }
  );

  return {
    lat: totals.lat / boundaries.length,
    lng: totals.lng / boundaries.length,
  };
}

function resolvePreferredMapCenter(fieldState, searchLocation) {
  const boundaries = getAuthoritativeBoundaryPoints(fieldState);
  const boundaryCenter = calculateBoundaryCentroid(boundaries);

  if (boundaryCenter) {
    return boundaryCenter;
  }

  if (
    Number.isFinite(searchLocation?.lat) &&
    Number.isFinite(searchLocation?.lng)
  ) {
    return { lat: searchLocation.lat, lng: searchLocation.lng };
  }

  return null;
}

export {
  calculateBoundaryCentroid,
  getAuthoritativeBoundaryPoints,
  hasAuthoritativeFieldBoundaries,
  resolvePreferredMapCenter,
};
